import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { Button } from '../button';
import Select from '../select'
// import { Button } from '../../../components/button';
import * as Svg from "../svg";
import { getAllowedExportFields, getExportPreview, createExport } from "../../slices/export";
import Table from "../table";
// import { SaveIndicator } from "../save-indicator";
import { ExportIndicator } from "../export-indicator";
import moment from 'moment';

export const ListModal = ({
    show,
    onClose,
    onClick,
    apiService,
    TableComponent,
}) => {
    const [data, setData] = useState([])

    useEffect(() => {
        new Promise(resolve =>
            resolve(apiService)
        ).then(response => {
            setData(response)
        })
    }, [])

    if (!show) {
        return null;
    }

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <div className="modal-close" onClick={onClose}><Svg.SvgClose></Svg.SvgClose></div>
                <div className="table-body-scroll">
                    <TableComponent data={data} />
                </div>
            </div>
        </div>
    );
}

